import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { ContratoAction, useContrato } from '../../store';
import ContratoRescisaoForm from './ContratoRescisaoForm';
import ContratoRescisaoSchema from './ContratoRescisaoSchema';
import { rescisaoStyles } from './styles';

// RNE-505
const initialValues = { data: moment(new Date()), motivo: 'OUTRO' };

const ContratoRescisaoModal = () => {
  const [state, dispatch] = useContrato();
  const { registro, rescisaoContrato, requestParams, filtroAvancado } = state;

  const styles = rescisaoStyles();

  const onSubmitForm = (rescisao) => {
    ContratoAction.rescindirContrato(dispatch, rescisao, registro, requestParams, filtroAvancado);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: onSubmitForm,
    validationSchema: ContratoRescisaoSchema,
    validateOnBlur: true,
  });

  const { resetForm } = formik;
  useEffect(() => {
    resetForm({});
  }, [registro, resetForm]);

  const handleCancelar = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: () => ContratoAction.closeModalRescisaoContrato(dispatch),
      });
    } else {
      ContratoAction.closeModalRescisaoContrato(dispatch);
    }
  };

  return (
    <SimpleDialog
      open={rescisaoContrato}
      onClose={handleCancelar}
      paperClass={styles.paperClass}
      container={styles.container}
    >
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Rescindir contrato',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={<ContratoRescisaoForm />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContratoRescisaoModal;
